import { createContext } from 'react';

import type { UserContextData } from './types';

export const initialContext: UserContextData = {
  accountUuid: '',
  accountStatus: null,
  organizationalRole: null,
  parentAccountId: '',
  referencePrefix: null,
  divisions: [],
  userProfile: {
    accountUuid: '',
    division: null,
    isAdmin: false,
    isDivision: false,
    isParent: false,
    isProfileCompleted: false,
    isSingleSignOn: false,
    firstName: '',
    lastName: '',
    organizationalRole: null,
    role: null,
    email: '',
    phoneNumber: '',
    uuid: '',
    registeredCompanyName: ''
  },
  refetchUser: () => {}
};

const UserContext = createContext<UserContextData>(initialContext);

export default UserContext;
